import Head from 'next/head'
import styles from '../../styles/index.module.css'
import Script from 'next/script'

export default function Home() {

  return (
    <>
      <Head>
        <title>Limitation of Liability for Direct User – Service Provider Transactions</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content="These terms clarify StringsSG’s liability limitations regarding direct financial transactions and agreements between users and independent service providers connected through our platform."/>
        <meta name="keywords" content="We help you in HDB or Condo rental and purchase, health Investment and Insurance plan, food catering,
             domestic helper, handyman services, aircon servicing, beauty and massage, interior designing, fitness trainer, 
             wedding, birthday and other event planning"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:url"   content="https://www.stringssg.com/terms/limitation-of-liability-for-direct-user-service-provider-transaction" />
        <meta property="og:type"   content="website" />
        <meta property="og:title"    content={`Limitation of Liability for Direct User – Service Provider Transactions`}/>
        <meta property="og:description" content="These terms clarify StringsSG’s liability limitations regarding direct financial transactions and agreements between users and independent service providers connected through our platform." />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/terms/limitation-of-liability-for-direct-user-service-provider-transaction"/>
        <meta name="twitter:title" content={`Limitation of Liability for Direct User – Service Provider Transactions`}/> 
        <meta name="description" content="These terms clarify StringsSG’s liability limitations regarding direct financial transactions and agreements between users and independent service providers connected through our platform."/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/terms/limitation-of-liability-for-direct-user-service-provider-transaction"/>
        </Head>
            <div className={styles.main}>  
                <div className='max-w-4xl mx-auto py-4'>
                    <h1 className='text-gray-500 text-2xl text-center border-b p-4'>
                        Limitation of Liability for Direct User – Service Provider Transactions
                    </h1>
                    <div id="limited-liability" className='text-gray-500 p-4 space-y-6 py-8 leading-7 text-sm'>
                        <p>
                            StringsSG functions as a technology-driven platform that facilitates connections between users and a wide range of service providers across categories such as home services, fitness, event planning, personal care, property, and finance. These providers operate independently and are not employees, agents, or representatives of StringsSG unless otherwise stated in a formal contract.
                        </p>

                        <h2 className='text-lg font-semibold text-gray-600 mt-6'>Direct Engagement Outside the Platform</h2>
                        <p>
                            If a user chooses to engage a service provider directly — without completing a formal booking by direct payment to StringsSG, or without any written agreement through the StringsSG platform — such engagement is considered an independent arrangement. In these cases, StringsSG assumes no liability or responsibility for:
                        </p>
                        <ul className='list-disc list-inside pl-4'>
                            <li>The conduct or behavior of the service provider</li>
                            <li>The quality, legality, or outcome of the service</li>
                            <li>Financial disputes, non-performance, or refund claims</li>
                            <li>Losses arising from misrepresentation, fraud, or negligence</li>
                        </ul>

                        <h2 className='text-lg font-semibold text-gray-600 mt-6'>Applicability Across All Service Categories</h2>
                        <p>
                            This limitation of liability applies regardless of service category — including but not limited to aircon servicing, handyman services, or domestic helpers — if the client transacts directly with the provider outside the StringsSG platform.
                        </p>

                        <h2 className='text-lg font-semibold text-gray-600 mt-6'>Responsibility for Platform-Based Transactions</h2>
                        <p>
                            StringsSG only assumes responsibility for services that are formally booked, paid for, and documented through the StringsSG platform. These services are governed by specific terms outlined under our Consumer Client Terms and Warranty Policies. We encourage users to always use the built-in communication and payment tools on the platform for secure and traceable interactions.
                        </p>

                        <h2 className='text-lg font-semibold text-gray-600 mt-6'>Lead-Based Service Categories</h2>
                        <p>
                            For categories offered under StringsSG&apos;s lead-based model — such as personal training, financial advisory, property agency, interior design, and event planning — StringsSG&apos;s role is limited to providing an initial point of contact. In such cases:
                        </p>
                        <ul className='list-disc list-inside pl-4'>
                            <li>StringsSG does not verify or validate pricing, credentials, or service guarantees unless explicitly stated.</li>
                            <li>Clients are strongly encouraged to perform their own due diligence before engaging any service provider.</li>
                            <li>We recommend that clients request formal contracts, clearly stated deliverables, and official payment receipts to safeguard against potential disputes.</li>
                        </ul>

                        <h2 className='text-lg font-semibold text-gray-600 mt-6'>Summary and Recommendation</h2>
                        <p>
                            For the best experience and protection, users should always transact within the StringsSG ecosystem. If you choose to bypass the platform and engage a provider directly, you do so at your own risk. StringsSG disclaims all liability in such cases.
                        </p>
                    </div>
                </div>
            </div>
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
        />
        <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
                      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                      n.queue=[];t=b.createElement(e);t.async=!0;
                      t.src=v;s=b.getElementsByTagName(e)[0];
                      s.parentNode.insertBefore(t,s)}(window, document,'script',
                      'https://connect.facebook.net/en_US/fbevents.js');
                      fbq('init', '128634041116395');
                      fbq('track', 'PageView');`}
        </Script>
    </>
  )
}